import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  deleteFastTracks,
  readFastTrackItems,
  readFastTrackPrompts,
  readFlow,
  shareFastTrackWithUsers,
  shareFastTrackWithClientGroup,
  updateFastTrackName,
} from '@api/fast_tracks';
import { toast } from '@utilities';

import Delete from '../../components/ListPage/components/ActionsToolbar/components/Delete';
import Details from '../../components/ListPage/components/ActionsToolbar/components/Details';
import ItemAnswers from '../../components/ItemAnswers';
import FlowDownload from '../../components/ListPage/components/ActionsToolbar/components/FlowDownload';
import ListPage from '../../components/ListPage';
import ModalBuildFastTrack from '../../../FastTracks/components/ModalBuildFastTrack';
import Rename from '../../components/ListPage/components/ActionsToolbar/components/Rename';
import Reprompt from '../../components/ListPage/components/ActionsToolbar/components/Reprompt';
import Share from '../../components/ListPage/components/ActionsToolbar/components/Share';

import { FILTER_OPTIONS, ITEM_COLUMNS } from './utilities/helpers';

const FastTracks = () => {
  const navigate = useNavigate();
  const [flow, setFlow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isModalOpen) {
      setFlow(null);
    }
  }, [isModalOpen]);

  const fastTrackRoute = useMemo(() => {
    if (!flow) return {};
    return {
      id: flow?.fast_track_id,
      name: flow?.fastTrackName,
      path: `/dashboard/narrative/${flow?.fast_track_id}`,
    };
  }, [flow]);

  const handleReprompt = async (selectedFlow) => {
    const flowId = selectedFlow?.id;

    try {
      const response = await readFlow({ id: flowId });
      if (response?.answers && response?.fast_track_id && response?.fastTrackName) {
        setFlow(response);
        setIsModalOpen(true);
      } else {
        toast('An error occurred while reprompting this Narrative.', { status: 'error' });
      }
    } catch (error) {
      console.error(error);
      toast('An error occurred while reprompting this Narrative.', { status: 'error' });
    }
  };
  return (
    <>
      <ListPage
        filterOptions={FILTER_OPTIONS}
        itemActions={[
          <Details />,
          <Rename
            type="Narrative"
            updateName={({ name, row }) => updateFastTrackName({ id: row.id, name })}
          />,
          <Reprompt handleReprompt={handleReprompt} />,
          <FlowDownload />,
          <Share
            shareWithClient={shareFastTrackWithClientGroup}
            shareWithUsers={shareFastTrackWithUsers}
          />,
          <Delete
            deleteItems={(selectedRows) =>
              deleteFastTracks({ ids: selectedRows.map(({ id }) => id) })
            }
          />,
        ]}
        itemColumns={ITEM_COLUMNS}
        onCreate={() => navigate('/dashboard/narratives')}
        readItems={readFastTrackItems}
        renderRowExpanded={({ row }) => (
          <ItemAnswers
            item={row?.original}
            readItemAnswers={readFlow}
            readPrompts={readFastTrackPrompts}
            type="Flow"
          />
        )}
        type="Narrative"
        workspace="FastTracks"
      />
      <ModalBuildFastTrack
        isModalOpen={isModalOpen}
        repromptFlow={flow || {}}
        route={fastTrackRoute}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default FastTracks;
